import {InputField} from '@/pages/components/common/InputField';
import {
    defaultTaxRepPhone,
    normalizeTaxRepPhone,
    sanitizeTaxRepPhoneInput,
} from '@/utils/taxRepPhone';

type Props = {
    value: string;
    onChange: (next: string) => void;
    label?: string;
    fullWidth?: boolean;
    display?: boolean;
    error?: boolean;
    helperText?: string;
    size?: 'small' | 'medium';
};

/**
 * Tax Rep Telephone Number � `(852)37569536` with area-code local-length caps.
 */
export function TaxRepTelephoneField({
                                         value,
                                         onChange,
                                         label = 'Telephone Number',
                                         fullWidth = true,
                                         display = false,
                                         error,
                                         helperText,
                                         size = 'small',
                                     }: Props) {
    const shown = display
        ? (value ? normalizeTaxRepPhone(value) : '')
        : (value ? sanitizeTaxRepPhoneInput(value) : defaultTaxRepPhone());

    return (
        <InputField
            fullWidth={fullWidth}
            size={size}
            variant="outlined"
            align="left"
            display={display}
            label={label}
            value={shown}
            error={error}
            helperText={helperText}
            onChange={(e) => {
                if (display) return;
                onChange(sanitizeTaxRepPhoneInput(e.target.value));
            }}
        />
    );
}
